import { api } from "@/lib/api";

/* ---- Endpoints ---- */
export async function fetchCountries() {
  const { data } = await api.get("/data-collector/countries");
  return data?.data || [];
}

export async function fetchCountryData(iso3) {
  const { data } = await api.get(`/data-collector/fetch/${iso3}`);
  return data?.data;
}

export async function saveDataset(payload) {
  const { data } = await api.post("/data-collector/save", payload);
  return data?.data;
}

export async function listSavedDatasets() {
  const { data } = await api.get("/data-collector/saved");
  return data?.data || [];
}

export async function deleteSavedDataset(id) {
  const { data } = await api.delete(`/data-collector/saved/${id}`);
  return data;
}

/* ---- Field labels (FR) ---- */
export const SECTION_A_LABELS = {
  total_public_debt:       "Dette publique totale",
  domestic_debt:           "dont Dette intérieure",
  external_debt:           "dont Dette extérieure",
  debt_to_gdp_pct:         "Ratio Dette / PIB (%)",
  annual_debt_service:     "Service annuel de la dette",
  interest_payments:       "dont Intérêts annuels",
  principal_repayments:    "dont Remboursements de capital",
  average_interest_rate:   "Taux d'intérêt moyen (%)",
  average_maturity_years:  "Maturité moyenne (années)",
  annual_fiscal_deficit:   "Déficit budgétaire annuel",
  total_gdp:               "PIB total",
};

export const SECTION_B_LABELS = {
  total_population:    "Population totale (habitants)",
  active_population:   "Population active / contribuables",
  population_under_18: "Population de moins de 18 ans",
};

/* ---- Helpers ---- */
export function fmtNumber(n, opts = {}) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2, ...opts }).format(n);
}

export function buildJsonExport(country, ds) {
  return {
    country_iso3: country.iso3,
    country_name: country.name,
    currency: country.currency_code,
    reference_year: ds.reference_year || null,
    macro: Object.fromEntries(
      Object.entries(ds.section_a_macro || {}).map(([k, v]) => [k, v?.value ?? null])
    ),
    demographics: Object.fromEntries(
      Object.entries(ds.section_b_demo || {}).map(([k, v]) => [k, v?.value ?? null])
    ),
    sources: ds.sources || [],
    generated_at: new Date().toISOString(),
  };
}

export function buildCsv(country, ds) {
  // Format aligné sur l'import Vitae-publica :
  // section,key,label,value,year,source
  const rows = [["section", "key", "label", "value", "year", "source"]];
  Object.entries(ds.section_a_macro || {}).forEach(([k, v]) => {
    rows.push(["A_macro", k, SECTION_A_LABELS[k] || k,
               v?.value ?? "", v?.year ?? "", v?.source ?? ""]);
  });
  Object.entries(ds.section_b_demo || {}).forEach(([k, v]) => {
    rows.push(["B_demo", k, SECTION_B_LABELS[k] || k,
               v?.value ?? "", v?.year ?? "", v?.source ?? ""]);
  });
  return rows
    .map((r) =>
      r
        .map((c) => {
          const s = String(c ?? "");
          return s.includes(",") || s.includes('"') || s.includes("\n")
            ? `"${s.replaceAll('"', '""')}"`
            : s;
        })
        .join(",")
    )
    .join("\n");
}
